import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { GALLERY } from "../data";

const Tile = ({ item, index }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 60 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
      data-testid={`gallery-tile-${index}`}
      className={`group relative overflow-hidden rounded-2xl ${item.span} ${item.h}`}
    >
      <motion.img
        src={item.src}
        alt={item.label}
        style={{ y }}
        className="h-[116%] w-full scale-105 object-cover transition-transform duration-[900ms] ease-out group-hover:scale-100"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/45 via-transparent to-transparent opacity-70" />
      <div className="absolute bottom-5 left-5 flex items-center gap-3 opacity-0 transition-opacity duration-500 group-hover:opacity-100">
        <span className="h-px w-8 bg-[#EAD39C]" />
        <span className="font-body text-xs uppercase tracking-[0.25em] text-[#FCFBF8]">
          {item.label}
        </span>
      </div>
    </motion.div>
  );
};

export const Gallery = () => {
  return (
    <section id="gallery" className="relative bg-[#F3F1EC] py-24 sm:py-32 lg:py-40">
      <div className="mx-auto max-w-[1500px] px-6 sm:px-12 lg:px-16">
        <div className="mb-14 flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <div>
            <div className="mb-6 flex items-center gap-4">
              <span className="h-px w-14 bg-[#C5A059]" />
              <span className="font-body text-xs font-semibold uppercase tracking-[0.3em] text-[#A37E3A]">
                Selected Work
              </span>
            </div>
            <h2 className="font-heading text-4xl font-light leading-[1.05] tracking-tight text-[#1A1918] sm:text-5xl lg:text-6xl">
              A gallery of <span className="italic text-gradient-gold">golden</span> moments.
            </h2>
          </div>
          <p className="max-w-sm font-body text-base leading-relaxed text-[#5C5A56]">
            Real celebrations designed and delivered by our team across Mangaluru and beyond.
          </p>
        </div>

        <div className="grid auto-rows-min grid-cols-1 gap-4 md:grid-cols-12 lg:gap-6">
          {GALLERY.map((item, i) => (
            <Tile key={i} item={item} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
};
